var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5587",
    "data-name": "Group 5587",
    transform: "translate(0.488 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_499",
    "data-name": "Ellipse 499",
    cx: 56,
    cy: 56,
    r: 56,
    transform: "translate(0.012)",
    fill: "#f4f4f4",
    stroke: "#e0e0e0",
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rocket-1",
    transform: "translate(19.491 20.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H71.9V71.9H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M15.925,24.6a1.438,1.438,0,0,1,2.034,2.034l-3.587,3.587a3.974,3.974,0,0,1-5.621,0L5.164,26.629a3.974,3.974,0,0,1,0-5.621l3.587-3.587a1.438,1.438,0,1,1,2.034,2.034L7.2,23.042a1.1,1.1,0,0,0,0,1.553l3.587,3.587a1.1,1.1,0,0,0,1.553,0Z",
    transform: "translate(7.504 31.893)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M29.743,17.457,12.906,38.739a1.438,1.438,0,0,0,.111,1.909L21,48.628a1.438,1.438,0,0,0,1.909.111L44.188,31.9C51.877,25.82,55.831,16.245,54.521,7.124,45.4,5.814,35.825,9.768,29.743,17.457ZM26.417,49.628,24.69,50.994a4.314,4.314,0,0,1-5.727-.333l-7.98-7.98a4.314,4.314,0,0,1-.333-5.727l1.366-1.727L3.64,29.643a1.438,1.438,0,0,1-.1-2.319l10.069-8.056A10.066,10.066,0,0,1,24.4,18.125l.814.407.008,0,2.266-2.864C34.441,6.883,45.556,2.507,56.036,4.459a1.438,1.438,0,0,1,1.15,1.15c1.953,10.48-2.423,21.595-11.213,28.549l-2.864,2.265,0,.008.407.814a10.066,10.066,0,0,1-1.143,10.79L34.321,58.105A1.438,1.438,0,0,1,32,58l-5.585-8.377Zm2.263-1.79L33.3,54.773l6.827-8.534a7.19,7.19,0,0,0,.817-7.707l-.143-.286L28.681,47.838ZM13.807,32.964,23.4,20.84l-.286-.143a7.19,7.19,0,0,0-7.707.816L6.872,28.341Z",
    transform: "translate(5.628 7.504)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M16.106,9.106a7.19,7.19,0,1,1,0,10.168A7.19,7.19,0,0,1,16.106,9.106Zm8.135,8.135a4.314,4.314,0,1,0-6.1,0A4.314,4.314,0,0,0,24.241,17.241Z",
    transform: "translate(26.265 13.132)",
    fill: "#fe9920"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProPlan);
export default __webpack_public_path__ + "static/media/pro-plan.e3a8e5862149c827ab71493d3d4076ae.svg";
export { ForwardRef as ReactComponent };